import React, { Suspense, useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./assets/css/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./Layout";
import { localBusinessJsonLd } from "./seo/localBusinessJsonLd";

const Home = React.lazy(() => import("./screens/Home"));
const AboutUs = React.lazy(() => import("./screens/AboutUs"));
const OurProjects = React.lazy(() => import("./screens/OurProjects"));
const Services = React.lazy(() => import("./screens/Services"));
const PrivacyPolicy = React.lazy(() => import("./screens/Legal/PrivacyPolicy"));
const TermsOfService = React.lazy(() => import("./screens/Legal/TermsOfService"));

const JSON_LD_SCRIPT_ID = "rs-jsonld-local-business";

function App() {
  useEffect(() => {
    if (document.getElementById(JSON_LD_SCRIPT_ID)) return;
    const script = document.createElement("script");
    script.id = JSON_LD_SCRIPT_ID;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(localBusinessJsonLd);
    document.head.appendChild(script);
  }, []);

  return (
    <Router basename={process.env.REACT_APP_BASENAME}>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Layout landing><Home /></Layout>} />
          <Route path="/rapid-estimates" element={<Layout landing><Home /></Layout>} />
          <Route path="/aboutus" element={<Layout landingChrome><AboutUs /></Layout>} />
          <Route path="/ourprojects" element={<Layout landingChrome><OurProjects /></Layout>} />
          <Route path="/services" element={<Layout landingChrome><Services /></Layout>} />
          <Route path="/privacy-policy" element={<Layout legalMinimal><PrivacyPolicy /></Layout>} />
          <Route path="/terms-of-service" element={<Layout legalMinimal><TermsOfService /></Layout>} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
